























import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import VideoSelect from '@/components/staff/VideoSelect.vue'
@Component({
  components: { VideoSelect },
})
export default class PrivateVideo extends Vue {
  @Prop({ required: true, default: null }) public videoId!: string | null

  public showMiniModal = false
  public selectedVideoId: string | null = this.videoId

  showVideoScreen() {
    this.showMiniModal = true
    this.$nextTick(() => {
      const select = this.$refs.select as HTMLSelectElement
      select && select.focus()
    })
  }

  startVideo() {
    this.showMiniModal = false
    this.$emit('startWatchingVideo', this.selectedVideoId)
  }

  stopVideo() {
    this.selectedVideoId = null
    this.showMiniModal = false
    this.$emit('stopWatchingVideo')
  }

  closeModal() {
    this.showMiniModal = false
    this.selectedVideoId = null
  }

  @Watch('videoId')
  public changeVideoId(val: string | null) {
    this.selectedVideoId = val
  }
}
